<template>
  <div id="app">
    <router-view></router-view>
    <browserTips :tipMsg="tipMsg"></browserTips>
  </div>
</template>
<script>

  import * as versionService from './data/versionService';
  import packageJson from './../package';
import browserTips from '@/components/browserTips/browserTips.vue'
export default {
  name: 'app',
  data(){
    return {
      tipMsg:{
        title:'浏览器兼容性提醒',
        content:'检测到当前使用的浏览器存在兼容性问题，可能会出现界面显示异常，甚至部分功能无法正常使用的情况。推荐您使用谷歌、火狐浏览器访问！',
        downloadUrl:'https://pc.qq.com/detail/1/detail_2661.html',
      },
      isChecking: false,
      refuseUpgrade: false
    }
  },

  components: {
    'browserTips':browserTips,
  },
  methods: {
    checkVersion() {
      if (this.isChecking) {
        return;
      }
      this.isChecking = true

      versionService.checkVersion().then((result) => {
        const version = versionService.parseVersion(result.data);
        const myVersion = packageJson.version;
        if (version > myVersion) {
          this.$confirm('有新版本，是否刷新访问？', '系统升级提示').then(() => {
            window.location.reload(true);
          }).catch(() => {
            this.refuseUpgrade = true;
          }).finally(() => {
            this.isChecking = false;
          });
        } else {
          this.isChecking = false;
        }
      }).catch((error) => {
        this.isChecking = false;
      });
    }
  },

  created () {
    this.checkVersion();
    this.timer = setInterval(() => {
      if (!this.refuseUpgrade) {
        this.checkVersion();
      }
      else {
        clearInterval(this.timer);
        this.timer = null;
      }
    }, 1000 * 10);
  }

}

</script>
<style lang="stylus">
* {
  padding: 0;
  margin: 0;
}

body,
html {
  width: 100%;
  height: 100%;
}

#app {
  font-family: '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  background: #f8f8fa;
}
.el-tooltip__popper{
    max-width: 80%;
    line-height: 150%;
    data-html: true;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// App.vue?de57bc66